export default "__VITE_ASSET__DzE56tn4__"